import { render, staticRenderFns } from "./flavor-info.vue?vue&type=template&id=ece97040&"
import script from "./flavor-info.vue?vue&type=script&lang=js&"
export * from "./flavor-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ece97040')) {
      api.createRecord('ece97040', component.options)
    } else {
      api.reload('ece97040', component.options)
    }
    module.hot.accept("./flavor-info.vue?vue&type=template&id=ece97040&", function () {
      api.rerender('ece97040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/flavor/flavor-info.vue"
export default component.exports